import React, { useState } from "react";
import { Button } from "react-bootstrap";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Charts from "./Cartis"; // Chart component
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";
// Single CardBox
const CardBox = ({ iconClass, color, value, label }) => (
  
  <div className="col-md-4 col-sm-6 mb-4">
    <div className="d-flex align-items-center shadow-sm p-3 border-1 border-dark rounded-4">
      <div
        className="d-flex justify-content-center align-items-center me-3"
        style={{
          width: "50px",
          height: "50px",
          backgroundColor: color,
          color: "#fff",
          fontSize: "20px",
        }}
      >
        <i className={iconClass}></i>
      </div>
      <div>
        <h5 className="mb-0 fw-bold">{value}</h5>
        <small className="text-muted">{label}</small>
      </div>
    </div>
  </div>
);

export default function Collection() {
  
  const [activeView, setActiveView] = useState("reports");

  const data = [
    {
      value: 610,
      label: "Total Enroll Students",
      iconClass: "bi bi-people-fill",
      color: "#8c57ff",
    },
    {
      value: "₹10608000",
      label: "Total Fees",
      iconClass: "bi bi-currency-rupee",
      color: "#57c900",
    },
    {
      value: "₹10904200",
      label: "Final Total Fees",
      iconClass: "bi bi-currency-rupee",
      color: "#ffb400",
    },
    {
      value: "₹0",
      label: "Total Registration Fees Received",
      iconClass: "bi bi-currency-rupee",
      color: "#8c57ff",
    },
    {
      value: "₹0",
      label: "Total Registration Fees",
      iconClass: "bi bi-currency-rupee",
      color: "#57c900",
    },
    {
      value: "₹0",
      label: "Total Registration Fees Due",
      iconClass: "bi bi-currency-rupee",
      color: "#ffb400",
    },
    {
      value: "₹406200",
      label: "Total Bus Fees Received",
      iconClass: "bi bi-currency-rupee",
      color: "#8c57ff",
    },
    {
      value: "₹3125550",
      label: "Total Bus Fees",
      iconClass: "bi bi-currency-rupee",
      color: "#57c900",
    },
    {
      value: "₹2719350",
      label: "Total Bus Fees Due",
      iconClass: "bi bi-currency-rupee",
      color: "#ffb400",
    },
    {
      value: "₹1400376",
      label: "Total Fees Received",
      iconClass: "bi bi-currency-rupee",
      color: "#8c57ff",
    },
    {
      value: "₹12629374",
      label: "Total Due Fees",
      iconClass: "bi bi-currency-rupee",
      color: "#57c900",
    },
  ];


const chartData = [
  { name: "Enroll", value: 610 },
  { name: "Total Fees", value: 1000 },
  { name: "Final Total", value: 100 },
  { name: "Reg. Received", value: 0 },
  { name: "Reg. Fees", value: 0 },
  { name: "Reg. Due", value: 0 },
  { name: "Bus Received", value: 4000 },
  { name: "Bus Total", value: 31250 },
  { name: "Bus Due", value: 2710 },
  { name: "Fees Received", value: 1376 },
  { name: "Due Fees", value: 1274 }
];
  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Nav />
        <div className="layout-page">
          <Header />
          <div className="container-fluid">
            <div className=" py-4">
              {/* Button Group */}
              <div className="mb-4 d-flex flex-wrap gap-2">
                <Button
                  variant={activeView === "reports" ? "primary" : "outline-primary"}
                  className="text-nowrap"
                  onClick={() => setActiveView("reports")}
                >
                  Reports
                </Button>

                <Button
                  variant={activeView === "transactions" ? "primary" : "outline-primary"}
                  className="text-nowrap"
                  onClick={() => setActiveView("transactions")}
                >
                  Transactions
                </Button>

                <Button
                  variant={activeView === "batch" ? "primary" : "outline-primary"}
                  className="text-nowrap"
                  onClick={() => setActiveView("batch")}
                >
                  Batch Wise Report
                </Button>
              </div>


              {/* Reports View (Dashboard Data + Chart) */}
              {activeView === "reports" && (
                <>
                  <h4 className="mb-4 fw-bold text-primary">Reports Overview</h4>
                  <div className="row">
                    {/* {data.map((item, index) => (
                      <CardBox
                        key={index}
                        iconClass={item.iconClass}
                        color={item.color}
                        value={item.value}
                        label={item.label}

                      />
                      
                    ))} */}
                    <div style={{ width: "95%", height: 400 }}>
      <ResponsiveContainer>
        <LineChart data={chartData} margin={{ top: 20, right: 30, left: 10, bottom: 10 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" angle={-25} textAnchor="end" interval={0} />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="value"
            stroke="#8884d8"
            activeDot={{ r: 8 }}
            strokeWidth={2}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
                  </div>
                  <div className="mt-4">
                    <Charts />
                  </div>
                </>
              )}

              {/* Transactions Section */}
              {activeView === "transactions" && (
                <>
                  {" "}
                  <div className="card shadow-sm p-4 rounded-4">
                    <form>
                      <div className="row mb-3">
                        {/* Session Filter */}
                        <div className="col-md-3">
                          <label className="form-label fw-bold">
                            Fillter Session
                          </label>
                          <select className="form-select">
                            <option>2024-2025</option>
                            <option>2023-2024</option>
                            <option>2022-2023</option>
                          </select>
                        </div>

                        {/* Select Batch */}
                        <div className="col-md-3">
                          <label className="form-label fw-bold">
                            Select Batch
                          </label>
                          <select className="form-select">
                            <option>All Students Report</option>
                            <option>Batch A</option>
                            <option>Batch B</option>
                          </select>
                        </div>

                        {/* Payment Type */}
                        <div className="col-md-3">
                          <label className="form-label fw-bold">
                            Payment Type
                          </label>
                          <select className="form-select">
                            <option>All</option>
                            <option>Cash</option>
                            <option>Online</option>
                          </select>
                        </div>

                        {/* From Date */}
                        <div className="col-md-3">
                          <label className="form-label fw-bold">From Date</label>
                          <input type="date" className="form-control" />
                        </div>
                      </div>

                      <div className="row mb-3">
                        {/* To Date */}
                        <div className="col-md-3">
                          <label className="form-label fw-bold">To Date</label>
                          <input
                            type="date"
                            className="form-control"
                            defaultValue="2025-06-07"
                          />
                        </div>

                        {/* Remark */}
                        <div className="col-md-6">
                          <label className="form-label fw-bold">Remark</label>
                          <input
                            type="text"
                            className="form-control input-uppercase"
                            placeholder="Remark"
                          />
                        </div>

                        {/* Buttons */}
                        <div className="col-md-3 d-flex align-items-end gap-2">
                          <button type="submit" className="btn btn-primary w-50">
                            Fillter
                          </button>
                          <button type="reset" className="btn btn-danger w-50">
                            Reset
                          </button>
                        </div>
                      </div>

                      {/* Result Summary */}
                      <div className="mt-3">
                        <p className="mb-1 fw-bold text-success">
                          Total Transactions : 0
                        </p>
                        <p className="fw-bold text-success">
                          Total Amount Recived : ₹0
                        </p>
                      </div>
                    </form>
                  </div>{" "}
                  <div className="card shadow-sm p-4 rounded-4 mt-5">
                    <h5 className="fw-bold mb-3">Transactions (This Month)</h5>
                    <div className="table-responsive">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr className="bg-primary text-white">
                            <th scope="col">#</th>
                            <th scope="col">Trans Id</th>
                            <th scope="col">Student Name</th>
                            <th scope="col">Mobile</th>
                            <th scope="col">Payment Method</th>
                            <th scope="col">Amount</th>
                            <th scope="col">Payment Date</th>
                            <th scope="col">Remark</th>
                            <th scope="col">Fee Type</th>
                            <th scope="col">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* Example Row */}
                          <tr>
                            <td>1</td>
                            <td>TXN123456</td>
                            <td>Akshita Devana</td>
                            <td>9950367007</td>
                            <td>Cash</td>
                            <td>₹5000</td>
                            <td>2025-06-07</td>
                            <td>Admission Fee</td>
                            <td>Monthly</td>
                            <td>
                              <div className="dropdown">
                                <button
                                  className="btn buttonstyel"
                                  data-bs-toggle="dropdown"
                                >
                                  <i className="bi bi-three-dots-vertical"></i>
                                </button>
                                <ul className="dropdown-menu dropdown-menu-end">
                                  <li>
                                    <button
                                      className="dropdown-item"

                                    >
                                      Edit
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className="dropdown-item"

                                    >
                                      Delete
                                    </button>
                                  </li>

                                </ul>
                              </div>

                            </td>
                          </tr>
                          {/* More rows can go here */}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>
              )}

              {/* Batch Wise Report Section */}
              {activeView === "batch" && (
                <div className=" my-4">
                  {/* Filter Section */}
                  <div className="card shadow-sm p-4 rounded-4 mb-4">
                    <div className="row g-3 align-items-center">
                      <div className="col-md-4">
                        <label className="form-label fw-bold">Fillter Session</label>
                        <select className="form-select">
                          <option>2024-2025</option>
                          <option>2023-2024</option>
                        </select>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label fw-bold">Select Batch</label>
                        <select className="form-select">
                          <option>Select Batch to Find Data</option>
                          <option>Batch A</option>
                          <option>Batch B</option>
                        </select>
                      </div>
                      <div className="col-md-4 d-flex align-items-end gap-2">
                        <button className="btn btn-primary">Filter</button>
                        <button className="btn btn-danger">Reset</button>
                      </div>
                    </div>
                  </div>

                  {/* Table Section */}
                  <div className="card shadow-sm p-4 rounded-4">
                    <h5 className="fw-bold mb-3">Students Fee Report</h5>
                    <div className="table-responsive">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr className="bg-primary text-white">
                            <th>#</th>
                            <th>Student Name</th>
                            <th>Mobile</th>
                            <th>Course & Batch</th>
                            <th>Total Fees</th>
                            <th>Paid Amount</th>
                            <th>Left Amount</th>
                            <th>Next Payment Date</th>
                            <th>Last Transaction & Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* Sample Row */}
                          <tr>
                            <td>1</td>
                            <td>Riya Sharma</td>
                            <td>9876543210</td>
                            <td>10th - A</td>
                            <td>₹25,000</td>
                            <td>₹10,000</td>
                            <td>₹15,000</td>
                            <td>10/07/2025</td>
                            <td>₹5,000 on 06/06/2025</td>
                          </tr>
                          {/* More rows can go here */}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}

              {/* Dashboard Default View */}
        
            </div></div>
        </div>
      </div>
    </div>
  );
}
